import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactsManagementComponent } from './contacts-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ContactCrudModalComponent } from './modals/contact-crud-modal/contact-crud-modal.component';
import { ContactManagementWidgetComponent } from './contact-management-widget/contact-management-widget.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [ContactsManagementComponent, ContactCrudModalComponent, ContactManagementWidgetComponent],
  imports: [
    CommonModule,
    FormsModule,
    ConfirmModalModule,
    ErrorsModule,
    InlineSVGModule,
    LoadingModule,
    ReactiveFormsModule,
    FGBSharedModule,
    PipesModule,
    RouterModule
  ],
  exports: [ContactsManagementComponent, ContactCrudModalComponent, ContactManagementWidgetComponent],
})
export class ContactsManagementModule {}
